import { render } from "./modalFollowers.vue?vue&type=template&id=79cf228e&scoped=true"
import script from "./modalFollowers.vue?vue&type=script&lang=js"
export * from "./modalFollowers.vue?vue&type=script&lang=js"

import "./modalFollowers.vue?vue&type=style&index=0&id=79cf228e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cf228e"]])

export default __exports__